import React from "react";

/**
 * 6桁のコード入力フィールド（共通コンポーネント）
 */
export const CodeInputField: React.FC<{
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}> = ({ value, onChange, disabled = false, placeholder = "6桁のコード" }) => {
  return (
    <input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      maxLength={6}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        // 数字のみ許可
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        onChange(numericValue);
      }}
      className="w-full px-6 py-4 border border-neutral-300 rounded-2xl text-neutral-900 placeholder-neutral-400 focus:outline-none focus:border-primary transition-colors bg-white text-center text-2xl tracking-widest"
      disabled={disabled}
      required
      autoComplete="one-time-code"
    />
  );
};
